<template>
<div>
    <HeaderContent header="บทความ" :img_header="header_image" link_back="content" />
    <ContentBlogList />
</div>
</template>

<script>
import HeaderImage from '@/assets/copywriting.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import ContentBlogList from '@/components/menuadmin/content/contentblog/ContentBlogList.vue'

export default {
    name: 'contentBlog',
    components: {
        HeaderContent,
        ContentBlogList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
